import { useState } from 'react'
import { Card, Col, FormGroup, Row } from 'react-bootstrap'
import { t } from '../locale'
import KButton from '../components/KButton'

function Subdomain() {
  const [subdomain, setSubdomain] = useState('')

  const redirectToSubdomain = async () => {
    const value = subdomain
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '')
    if (!value) return

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/company/subdomain-exists?subdomain=${value}`
    )
    const data = await res.json()
    if (!data.available) {
      return
    }

    const { protocol, hostname, port } = window.location
    const hostParts = hostname.split('.')
    const baseDomain = hostParts.length >= 2 ? hostParts.slice(-2).join('.') : hostname
    const targetHost = `${value}.${baseDomain}`
    const portPart = port ? `:${port}` : ''

    window.location.href = `${protocol}//${targetHost}${portPart}`
  }

  return (
    <div className='container-fluid d-flex align-items-center justify-content-center py-4'>
      <div className='col-12 col-md-8 col-lg-6 col-xl-5'>
        <main>
          <Card className='border-0 shadow-sm'>
            <Card.Header>
              <strong>{t('subdomainHeader')}</strong>
            </Card.Header>
            <Card.Body className='p-4'>
              <form
                onSubmit={async e => {
                  e.preventDefault()
                  await redirectToSubdomain()
                }}
              >
                <Row>
                  <Col>
                    <FormGroup>
                      <input
                        className='form-control'
                        id='subdomain'
                        type='text'
                        value={subdomain}
                        onChange={e => setSubdomain(e.target.value)}
                        required
                        autoComplete='on'
                        autoFocus
                        placeholder={t('companyNameSubdomain')}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col className='d-flex justify-content-start'>
                    <FormGroup>
                      <KButton
                        className='mt-3 px-3'
                        variant='success'
                        label={t('confirm')}
                        type='submit'
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </form>
            </Card.Body>
          </Card>
        </main>
      </div>
    </div>
  )
}

export default Subdomain
